import { format } from 'date-fns';
import { useMemo } from 'react';
import { SimpleDatePicker } from '@/components/DatePicker/SimpleDatePicker';
import { useFormatDate } from '@/hooks/date';
import { useTranslation } from '@/lib/i18n';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Props = CFormItemProps & {
  value?: Date | string;
  onChange?: (value: string) => void;
  inputWidth?: number | string;
  inputClassName?: string;
  allowEmpty?: boolean;
};

/**
 * Card-based Form / DateItem (OnlyDate string)
 */
export const CFormDateItem = buildCFormItem<Props>((props: Props) => {
  const formatDate = useFormatDate();
  const {
    i18n
  } = useTranslation();
  const displayValue = useMemo(() => {
    if (!props.value) return '';
    return formatDate(props.value);
  }, [props.value, formatDate]); // 元の依存配列に戻す

  return <CFormItemBase {...props} key={`date-${i18n.language}`} // 言語切り替え時に強制再レンダリング
  readComponent={displayValue} writeComponent={<SimpleDatePicker value={props.value ? new Date(props.value) : undefined} width={props.inputWidth ?? 180} allowEmpty={props.allowEmpty} onChange={value => props.onChange?.(value ? format(value, 'yyyy-MM-dd') : '')} className={props.inputClassName ?? 'w-full'} disabled={props.readonly} />} />;
});